import React, { useEffect, useState } from 'react'
import { useNavigate, useParams } from 'react-router-dom';
import { useForm } from "react-hook-form";
import bookingService from '../../services/booking.service';
import playroomService from '../../services/playroom.service';
import { BiError } from 'react-icons/bi';
import { Button, Checkbox, Col, Form, Input, InputNumber, Row, Select } from 'antd';
import TextArea from 'antd/es/input/TextArea';

export default function UpdateBooking() {

    const { bookingId, playroomId } = useParams();
    const [playroom, setPlayroom] = useState({});
    const [booking, setBooking] = useState({});
    const [form] = Form.useForm();
    const navigate = useNavigate();

    useEffect(() => {
        fetchData();
    }, []);

    const onFinish = (values) => {
        const updatedValues = {
            ...values,
            expectedNumberOfAdults: Number(values.expectedNumberOfAdults),
            expectedNumberOfChildren: Number(values.expectedNumberOfChildren),
        };

        console.log(updatedValues);
        bookingService.updateBooking(updatedValues, bookingId).then((response) => {
            if (response.status === 200) {
                navigate("/reservations");
            }
        }).catch((err) => {
            console.log(err);
        });
    };

    const fetchData = () => {
        bookingService.getById(bookingId)
            .then((response) => {
                if (response.status === 200) {
                    const bookingData = response.data;
                    setBooking(bookingData);
                    console.log("booking --- ", response.data);
                    form.setFieldsValue({
                        ...bookingData,
                        packageId: bookingData.package?.id,

                    });
                }
            }).catch((err) => {
                console.log(err);
            });

        playroomService.getById(playroomId)
            .then((response) => {
                if (response.status === 200) {
                    setPlayroom(response.data);
                }
            }).catch((err) => {
                console.log(err);
            });
    };

    return (
        <div className="flex items-center justify-center min-h-screen p-6 bg-cover bg-center overflow-y-auto">
            <div className="w-full max-w-md p-6 bg-datepickerGray rounded-lg shadow-lg">
                <Form
                    form={form}
                    layout="vertical"
                    onFinish={onFinish}
                    initialValues={{
                        packageId: booking.package?.id,
                        specialOffersIds: booking.specialOffers?.map(x => x.id) // Set initial value here for the Select
                    }}
                >
                    <h4 className="text-footerBlue text-2xl font-bold text-center mb-6">Ažuriranje rezervacije</h4>

                    <Row gutter={16}>
                        <Col span={12}>
                            <label className="block text-footerBlue font-semibold mb-2" htmlFor="expectedNumberOfAdults">
                                Očekivani broj odraslih
                            </label>
                            <Form.Item
                                name="expectedNumberOfAdults"
                                rules={[{ required: true, message: 'Ovo polje je obavezno!' }]}
                            >
                                <InputNumber
                                    min={0}
                                    placeholder="Broj odraslih"
                                    className="w-full font-semibold"
                                />
                            </Form.Item>
                        </Col>

                        <Col span={12}>
                            <label className="block text-footerBlue font-semibold mb-2" htmlFor="expectedNumberOfChildren">
                                Očekivani broj djece
                            </label>
                            <Form.Item
                                name="expectedNumberOfChildren"
                                rules={[{ required: true, message: 'Ovo polje je obavezno!' }]}
                            >
                                <InputNumber
                                    min={0}
                                    placeholder="Broj djece"
                                    className="w-full font-semibold"
                                />
                            </Form.Item>
                        </Col>
                    </Row>

                    <label className="block text-footerBlue font-semibold mb-2" htmlFor="email">
                        Email
                    </label>
                    <Form.Item
                        name="customerEmail"
                        rules={[{ required: true, message: 'Ovo polje je obavezno!', type: 'email' }]}
                    >
                        <Input
                            className="font-semibold"
                            placeholder="Unesite email" />
                    </Form.Item>

                    <label className="block text-footerBlue font-semibold mb-2" htmlFor="phoneNumber">
                        Broj telefona
                    </label>
                    <Form.Item
                        name="customerPhoneNumber"
                        rules={[{ required: true, message: 'Ovo polje je obavezno!' }]}
                    >
                        <Input
                            className="font-semibold"
                            placeholder="Unesite broj telefona" />
                    </Form.Item>

                    <label className="block text-footerBlue font-semibold mb-2" htmlFor="childName">
                        Ime slavljenika
                    </label>
                    <Form.Item
                        name="childName"
                        rules={[{ required: true, message: 'Ovo polje je obavezno!' }]}
                    >
                        <Input
                            className="font-semibold"
                            placeholder="Unesite ime slavljenika" />
                    </Form.Item>

                    <label className="block text-footerBlue font-semibold mb-2" htmlFor="note">
                        Napomena
                    </label>
                    <Form.Item
                        name="note"
                        rules={[{ required: true, message: 'Ovo polje je obavezno!' }]}
                    >
                        <TextArea className="font-semibold"
                            rows={4}
                            placeholder="Unesite napomenu!" />
                    </Form.Item>

                    <label className="block text-footerBlue font-semibold mb-2" htmlFor="packageId">
                        Paket
                    </label>
                    <Form.Item
                        name="packageId"
                        rules={[{ required: true, message: 'Ovo polje je obavezno!' }]}
                    >
                        <Select
                            className="font-semibold"
                            options={playroom.packages?.map((pkg) => ({
                                label: pkg.packageName,
                                value: pkg.id,
                            }))}
                        />
                    </Form.Item>
                    <Form.Item>
                        <Button
                            type="submit"
                            htmlType="submit"
                            className="w-full bg-buttonYellow text-footerBlue font-bold py-2 rounded-md"
                        >
                            AŽURIRAJ
                        </Button>
                    </Form.Item>
                </Form>
            </div>
        </div>
    )
}
